var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "footer" }, [
    _c("div", { staticClass: "f-main" }, [
      _c("div", { staticClass: "f-left" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "f-item" }, [
          _c("h3", [_vm._v("服务支持")]),
          _vm._v(" "),
          _c("div", { staticClass: "f-link" }, [
            _c("a", { attrs: { href: "/cad", target: "_blank" } }, [
              _vm._v("设计能力")
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.config.domain + "/technology/pcbCraft",
                  target: "_blank"
                }
              },
              [_vm._v("PCB生产制造")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.config.domain + "/technology/pcbACraft",
                  target: "_blank"
                }
              },
              [_vm._v("PCBA装联")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.config.domain + "/technology/bomCraft",
                  target: "_blank"
                }
              },
              [_vm._v("BOM配齐")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "f-item" }, [
          _c("h3", [_vm._v("关于我们")]),
          _vm._v(" "),
          _c("div", { staticClass: "f-link" }, [
            _c("a", { attrs: { href: _vm.config.domain + "/aboutUs" } }, [
              _vm._v("公司介绍")
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.config.domain + "/newsColumn?categoryId=128"
                }
              },
              [_vm._v("新闻动态")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.config.domain + "/newsColumn?categoryId=129"
                }
              },
              [_vm._v("通知公告")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  rel: "nofollow",
                  href: _vm.config.domain + "/supplier",
                  target: "_blank"
                }
              },
              [_vm._v("生态合作")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "f-item" }, [
          _c("h3", [_vm._v("帮助中心")]),
          _vm._v(" "),
          _c("div", { staticClass: "f-link" }, [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.config.domain + "/helpCenter/detail?detailId=16885"
                }
              },
              [_vm._v("下单流程")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.config.domain + "helpCenter/detail?detailId=16882"
                }
              },
              [_vm._v("付款流程")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.config.domain + "/helpCenter/detail?detailId=16881"
                }
              },
              [_vm._v("开票流程 ")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.config.domain + "/helpCenter/list?categoryId=127"
                }
              },
              [_vm._v("常见问题")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(1)
    ]),
    _vm._v(" "),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "f-item" }, [
      _c("h3", [_vm._v("热门服务")]),
      _vm._v(" "),
      _c("div", { staticClass: "f-link" }, [
        _c("a", { attrs: { href: "/index/inquire", target: "_blank" } }, [
          _vm._v("IDM一站式下单")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "/index/PCB", target: "_blank" } }, [
          _vm._v("PCB下单")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "/index/PCBA", target: "_blank" } }, [
          _vm._v("PCBA下单")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "/index/BOM", target: "_blank" } }, [
          _vm._v("BOM下单")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "f-right" }, [
      _c("p", { staticClass: "name" }, [
        _c("img", {
          staticStyle: {
            width: "158px",
            height: "32px",
            "border-right": "1px solid #646a6f"
          },
          attrs: { src: require("./bottom-logo2.svg"), alt: "InZ应龙" }
        }),
        _vm._v(" "),
        _c("img", {
          staticStyle: { width: "158px", height: "26px" },
          attrs: { src: require("./bottom-logo1.svg"), alt: "InZ应龙" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { "padding-left": "28px" } }, [
        _c("h3", { staticStyle: { margin: "24px 0" } }, [
          _vm._v("电话：400-688-2850")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mail close-bom" }, [
          _vm._v("商务合作：service@inzaowu.com")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mail" }, [
          _vm._v("供应商合作：supplier@inzaowu.com")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cont" }, [
        _c("img", {
          attrs: { src: require("./focusCode@2x1.jpg"), alt: "pcb打样_InZ应龙" }
        }),
        _vm._v(" "),
        _c("img", {
          attrs: { src: require("./focusCode@2x2.jpg"), alt: "pcb打样_InZ应龙" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copyright-main" }, [
      _c("div", { staticClass: "copyright" }, [
        _c(
          "a",
          { attrs: { href: "https://beian.miit.gov.cn", target: "_blank" } },
          [
            _vm._v(
              " 深圳市造物数字工业科技有限公司 @ All Rights Reserved 粤ICP备2023137608号"
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d1fe40a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d1fe40a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/footer/footer.vue
// module id = null
// module chunks = 